import { Text } from "./typography";
import { Image } from "./image";
import type { UseImageUploadReturn } from "../../hooks/useImageUpload";
import { IconCircleCheck, IconCloudUpload, IconTrash } from "@tabler/icons-react";
export interface ImageUploadProps {
    title?: string;
    hint?: string;
    uploadLabel?: string;
    acceptedFormats?: string;
    maxSizeMB?: number;
    disabled?: boolean;
    errors?: string[];
    imageUpload: UseImageUploadReturn;
    previewSize?: "small" | "medium" | "large";
    showFileName?: boolean;
    showFileSize?: boolean;
    className?: string;
}
const previewSizes = {
    small: "w-24 h-24",
    medium: "w-32 h-32",
    large: "w-40 h-40",
};
export function ImageUpload({ title, hint, uploadLabel = "Click to upload image", acceptedFormats = "PNG or JPG", maxSizeMB = 5, disabled = false, errors, imageUpload, previewSize = "medium", showFileName = true, showFileSize = true, className = "", }: ImageUploadProps) {
    const { preview, selectedFile, fileInputRef, handleFileSelect, handleRemove, handleButtonClick, } = imageUpload;
    const previewSizeClass = previewSizes[previewSize];
    return (<div className={`space-y-4 ${className}`}>
      {title && (<div>
          <Text variant="bodyLgBold" tone="dark" className="mb-2">
            {title}
          </Text>
          {hint && (<Text variant="body" tone="body" className="mb-4">
              {hint}
            </Text>)}
        </div>)}

      <input ref={fileInputRef} type="file" accept="image/png,image/jpeg,image/jpg" onChange={handleFileSelect} className="hidden" disabled={disabled}/>

      {!preview ? (<div onClick={disabled ? undefined : handleButtonClick} className={`border-2 border-dashed border-uiSecondary rounded-lg p-8 text-center transition-colors ${disabled
                ? "opacity-50 cursor-not-allowed"
                : "cursor-pointer hover:border-primary"}`}>
          <IconCloudUpload size={48} style={{
                color: "#6B7280",
                margin: "0 auto 16px"
            }}/>
          <Text variant="body" tone="dark" className="mb-2">
            {uploadLabel}
          </Text>
          <Text variant="bodyXs" tone="body">
            {acceptedFormats} (max {maxSizeMB}MB)
          </Text>
        </div>) : (<div className="border border-uiSecondary rounded-lg p-4">
          <div className="flex items-center gap-4">
            <div className={`${previewSizeClass} flex-shrink-0 rounded-lg overflow-hidden border border-uiSecondary`}>
              <Image image={preview.split(",")[1] || preview} alt="Image preview" size="w-full h-full object-cover"/>
            </div>
            <div className="flex-1">
              {showFileName && (<div className="flex items-center gap-2 mb-2">
                  <IconCircleCheck size={20} style={{
                    color: "#10B981"
                }}/>
                  <Text variant="body" tone="dark">
                    {selectedFile?.name || "Image selected"}
                  </Text>
                </div>)}
              {showFileSize && selectedFile && (<Text variant="bodyXs" tone="body">
                  {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                </Text>)}
            </div>
            <button onClick={handleRemove} className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed" disabled={disabled} type="button" aria-label="Remove image">
              <IconTrash size={24}/>
            </button>
          </div>
        </div>)}

      {errors && errors.length > 0 && (<div className="text-red-500 text-sm">
          {errors.map((error, index) => (<div key={index}>{error}</div>))}
        </div>)}
    </div>);
}
